import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link, Navigate, resolvePath } from "react-router-dom";

export default function Default() {
    useEffect(() => {
        AOS.init({ duration: 800, once: true });
    }, []);

    const sections = [
         {
            title: "کارنامه مستمر ماهانه",
            icon : "bi bi-check-circle text-success me-2",
            desc: [
                "امکان ایجاد کارنامه مستمر ماهانه مطابق نمرات ثبت شده توسط معلمان",
                "امکان چاپ کارنامه برای هر دانش آموز",
                "امکان چاپ کارنامه بصورت کلاسی",
                "امکان مشاهده کارنامه توسط اولیا و دانش آموزان در همین سامانه",
                "چاپ نمودار مقایسه وضعیت دانش آموزان با سایر دانش آموزان در کارنامه",
                "چاپ نمودار پیشرفت تحصیلی ماهانه دانش آموز در کارنامه"
            ],
            img: "/images/info/grade-sheet-logo.png",
        },
        {
            title: "مدیریت حضور و غیاب",
            icon : "bi bi-check-circle text-success me-2",
            desc: [
                "سیستم هوشمند ثبت حضور و غیاب، گزارش‌گیری سریع و دقیق، و امکان اطلاع‌رسانی لحظه‌ای به اولیا.",
                "معلمان در کمتر از یک دقیقه می توانند حضور و غیاب را انجام داده و کل حضور و غیاب مدرسه در چند دقیقه انجام خواهد شد",
                "مدیر یا معاون مدرسه وضعیت حضور و غیاب کل مدرسه را با رنگ بندی مناسب بررسی و در صورت نیار وضعیت را به اظلاع اولیای دانش آموزان غایب پیامک می کند",
                "امکان اصلاح حضور و غیاب توسط مدیر یا معاون مدرسه"
            ],
            img: "/images/info/present-absent-logo.png",
        },
        {
            title: "مدیریت نمرات مستمر",
            icon : "bi bi-check-circle text-success me-2",
            desc: [
                "ورود آسان نمرات، تحلیل پیشرفت تحصیلی دانش‌آموزان و دسترسی آنلاین برای معلمان و والدین.",
                "ثبت نمرات آزمون ها توسط معلمان به تعداد نامحدود برای هر درس",
                "امکان ثبت یک نمره نهائی برای هرماه جهت درج در کارنامه مستمر"

            ],
            img: "/images/info/exam-logo.png",
        },
        {
            title: "برنامه‌ریزی هفتگی",
            icon : "bi bi-check-circle text-success me-2",
            desc: [
                "امکان ثبت برنامه هفتگی توسط مدیر یا معاون.",
                "امکان اصلاح آسان برنامه هفتگی و جایگزینی معلمان",
                "امکان دریافت pdf  برنامه هفتگی و چاپ آن",
                "برنامه ریزی خودکار برای مدارس ابتدائی"
            ],
            img: "/images/info/weekly-timing-logo.png",
        },
        {
            title: "اطلاعیه و تابلو اعلانات",
            icon : "bi bi-check-circle text-success me-2",
            desc: [
                "امکان ایجاد آسان اطلاعیه",
                "امکان تنظیم مشاهده توسط همکاران، دانش آموزان و اولیا",
                "امکان تنظیم مهلت زمانی برای نمایش اطلاعیه",
                "امکان رنگ بندی قالب اطلاعیه ها",
            ],
            img: "/images/info/announce-logo.png",
        },
        {
            title: "اطلاع رسانی و پیامک",
            icon : "bi bi-check-circle text-success me-2",
            desc: [
                "امکان ارسال پیامک با کاربری بسیار آسان",
                "امکان ارسال پیامک به همکاران، دانش آموزان و اولیا",
                "امکان ارسال گروهی بر اساس کلاس",
                "امکان پیگیری تحویل پیامک به مخاطبین",
            ],
            img: "/images/info/sms-logo.png",
        },
        {
            title: "دفتر انضباط",
            icon : "bi bi-check-circle text-success me-2",
            desc: [
                "ثبت بی نظمی ها و فعالیت های ناهنجار دانش آموزان",
                "امکان تنظیم نمره منفی برای هر نوع بی نظمی",
                "مشاهده و چاپ کارنامه تربیتی",
                "امکان محاسبه و تنظیم نمره نهائی ماهانه برای انضباط دانش آموز جهت درج در کارنامه ماهانه"
            ],
            img: "/images/info/disipline-book-logo.png",
        },
    ];

    return (
        <div>
            {/* ===== Hero Section ===== */}
            <section className="bg-light py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div
                            className="col-md-6 text-center text-md-start"
                            data-aos="fade-right"
                            style={{ marginBottom: "20px", direction: "rtl" }}
                        >
                            <h1 className="fw-bold mb-3">
                                دستیار مدیر <span className="text-primary">کلاسیکو 7</span>
                            </h1>
                            <p className="lead text-muted mb-4">
                                مدیریت مدرسه را ساده‌تر، سریع‌تر و هوشمندتر تجربه کنید.
                            </p>
                            <a href="/login" className="btn btn-primary btn-lg px-4 py-2">
                                ورود به سامانه
                            </a>
                        </div>
                        <div className="col-md-6 text-center" data-aos="fade-left">
                            <img
                                src="/images/info/classico7-logo.png"
                                alt="کلاسیکو 7"
                                className="img-fluid rounded"
                                style={{ maxHeight: "180px" }}
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* ===== Features Section ===== */}
            <div className="container py-5">
                <h2 className="text-center mb-5 fw-bold">
                    امکانات <span className="text-primary">دستیار مدیر</span> در کلاسیکو 7
                </h2>
                <div className="row g-4">
                    {sections.map((s, idx) => (
                        <div
                            className="col-md-6"
                            key={idx}
                            data-aos={idx % 2 === 0 ? "fade-up" : "fade-down"}
                        >
                            <div className="card shadow-sm border-0 h-100">
                                <div className="row g-0 align-items-center">
                                    <div className="col-4 text-center p-3">
                                        <img
                                            src={s.img}
                                            alt={s.title}
                                            className="img-fluid rounded"
                                            style={{ maxHeight: "100px" }}
                                        />
                                    </div>
                                    <div className="col-8">
                                        <div className="card-body">
                                            <h5 className="card-title fw-bold">{s.title}</h5>
                                            <p className="card-text text-muted">
                                                {
                                                    s.desc.map((txt, index) => {
                                                        return (
                                                            <>
                                                                <i className={s.icon} style={{marginLeft:"5px"}}></i>
                                                                {txt}
                                                                <br />
                                                            </>
                                                        )
                                                    })}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <section className="bg-light py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div
                            className="col-md-6 text-center text-md-start"
                            data-aos="fade-right"
                            style={{ marginBottom: "20px", paddingRight:"20px", textAlign:"right", direction: "rtl" }}
                        >
                            <div style={{ paddingRight:"20px", textAlign:"right", direction: "rtl" }}>
                                <div style={{marginTop:"15px"}}>
                                    <i className="bi bi-crosshair text-success me-2" style={{marginLeft:"5px"}}></i>
                                    <Link to="/login" style={{textDecoration:"none", color:"#4862f7ff"}}>ورود به سامانه</Link>
                                </div>
                                <div style={{marginTop:"15px"}}>
                                    <i className="bi bi-crosshair text-success me-2" style={{marginLeft:"5px"}}></i>
                                    <Link to="/request-membership" style={{textDecoration:"none", color:"#4862f7ff"}}>درخواست عضویت مدرسه</Link>
                                </div>
                                <div style={{marginTop:"15px"}}>
                                    <i className="bi bi-crosshair text-success me-2" style={{marginLeft:"5px"}}></i>
                                    <Link to="/agent/request/membership" style={{textDecoration:"none", color:"#4862f7ff"}}>درخواست نمایندگی فروش</Link>
                                </div>
                            </div>
                            <div style={{textAlign:"center", direction:"rtl", borderTop:"1px dotted #b0b0b0", marginTop:"20px", borderBottom:"1px dotted #b0b0b0"}}>
                                تماس با ما: <label  style={{direction:"ltr"}}><a href="tel:09223455121">0922 345 5121</a></label>
                                <br/>
                                <a href="https://wa.me/9809223455121" target='_blank'><img src={require('../lib/images/whatsapp-icon.png')} style={{width:"48px", height:"48px", margin:"10px"}} /></a>
                                <a href="https://t.me/classico7ir" target='_blank'><img src={require('../lib/images/telegram-icon.png')} style={{width:"48px", height:"48px", margin:"10px"}} /></a>
                                <a href="https://www.instagram.com/@classico7ir" target='_blank'><img src={require('../lib/images/instagram-icon.png')} style={{width:"48px", height:"48px", margin:"10px"}} /></a>
                            </div>
                        </div>
                        <div className="col-md-6 text-center" data-aos="fade-left">
                            <img
                                src="/images/info/classico7-logo.png"
                                alt="کلاسیکو 7"
                                className="img-fluid rounded"
                                style={{ maxHeight: "180px" }}
                            />
                            <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=652614&Code=YtBrz6TjzUNJjPyvDBfgoJdPqgUulkXq'>
                            <img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=652614&Code=YtBrz6TjzUNJjPyvDBfgoJdPqgUulkXq' 
                                alt='' 
                                style={{cursor:"pointer"}} 
                                code='YtBrz6TjzUNJjPyvDBfgoJdPqgUulkXq' />
                            </a>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}
